module.exports = __webpack_public_path__ + "image-ddb7480c4e49.png";